import React from 'react'
import { Box, List, ListItem, Typography } from '@mui/material'

import { FormProps } from '../DynamicInputForm'
import Image from '../Image'

import { SignupForm } from './SignupForm'

type HeroProps = {
  data: {
    title: string
    content: {
      children: {
        text: string
      }[]
    }[]
    form_input_single_row: FormProps['formProps']
    icon_with_text_items: {
      title: string
      icon: {
        asset: {
          url: string
        }
      }
    }[]
    right_image: {
      asset: {
        url: string
      }
    }
    show_divider: boolean
  }
}

export const Hero = ({ data }: HeroProps) => (
  <Box
    sx={{
      background: { laptop: 'url("/images/info-landing-blur.png")' },
      backgroundRepeat: { laptop: 'no-repeat' },
      backgroundPositionY: { laptop: 100 },
      backgroundSize: { laptop: '100% 750px' },
      pt: { xs: 15, mobile: 14, laptop: 23 }
    }}>
    <Box
      sx={{
        maxWidth: 1152,
        mx: 'auto',
        pb: { xs: 6, mobile: 7, laptop: 9 },
        px: {
          xs: 3,
          mobile: 8,
          laptop: 4,
          desktop: 0
        }
      }}>
      <Box
        sx={{
          display: { xs: 'block', tablet: 'flex' }
        }}>
        <Box
          sx={{
            maxWidth: { xs: '100%', tablet: '50%', desktop: 500 },
            mr: { mobile: 4, laptop: 10.5 }
          }}>
          <Typography variant='h1' sx={{ letterSpacing: '-0.04em' }}>
            {data.title}
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: 12, mobile: 14, laptop: 18 },
              lineHeight: { xs: 1.6, mobile: 1.4 },
              maxWidth: { mobile: 412 },
              mt: { xs: 1, mobile: 2, laptop: 3 }
            }}>
            {data.content[0].children[0].text}
          </Typography>

          <SignupForm
            data={data.form_input_single_row}
            sx={{ mt: { xs: 2.5, laptop: 6 } }}
          />
        </Box>

        <Box
          sx={{
            mt: { xs: 7, mobile: 3.5, laptop: 3 },
            mx: { xs: 3, mobile: 0 }
          }}>
          <Image url={data.right_image.asset.url} width='566' />
        </Box>
      </Box>

      <List
        disablePadding
        sx={{
          display: 'flex',
          flexWrap: { xs: 'wrap', laptop: 'nowrap' },
          justifyContent: { mobile: 'center' },
          mt: { xs: 7, mobile: 8, laptop: 12 },
          rowGap: { xs: 2.5, mobile: 2 }
        }}>
        {data.icon_with_text_items?.map(item => (
          <ListItem
            key={item.title}
            disablePadding
            sx={{
              width: { xs: '50%', mobile: '33%' },
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column',
              px: { xs: 1, mobile: 2, laptop: 2.5 }
            }}>
            <Box
              sx={{
                width: { xs: 42, mobile: 48 },
                height: { xs: 42, mobile: 48 }
              }}>
              <Image url={item.icon.asset?.url} width='48' />
            </Box>
            <Typography
              variant='body2'
              sx={{
                fontSize: { xs: 14, laptop: 20 },
                lineHeight: 1.6,
                mt: 2,
                textAlign: 'center'
              }}>
              {item.title}
            </Typography>
          </ListItem>
        ))}
      </List>
    </Box>

    {data.show_divider && <Box className='section-divider' />}
  </Box>
)
